// extracted by mini-css-extract-plugin
module.exports = {"summaryItem":"summary_summaryItem_IEv8j","summaryTitle":"summary_summaryTitle_219Gu","summaryDes":"summary_summaryDes_2LVED"};